import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import {
  Button,
  CircularProgress,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AuthContext from "../../auth/context";
import { formatDateTime } from "../../helpers/helpers";
import serverHost from "../../services/serverHost";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/Delete";
import AttachFileIcon from "@mui/icons-material/AttachFile";

export default function Chamado(props) {
  const usuario = useContext(AuthContext);
  const { notification, confirm } = useContext(AppContext);
  const [chamadoId] = useState(Number(props.match.params.id));
  const [chamado, setChamado] = useState({});
  const [carregando, setCarregando] = useState(false);
  const history = props.history;
  const [responsaveis, setResponsaveis] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [exibindoAnexo, setExibindoAnexo] = useState(false);
  const [comentario, setComentario] = useState("");
  const [dadosAnexo, setDadosAnexo] = useState([]);
  const [inserindo, setInserindo] = useState(false);

  useEffect(() => {
    carregarUsuarios();
    carregar();
    carregarComentarios();
  }, []);

  const carregarUsuarios = () => {
    api
      .get("grupos/membros", { grupoCodIdentificador: "ADMIN_SISTEMA" })
      .then((res) => {
        setResponsaveis(res);
      });
  };

  const carregarComentarios = () => {
    api
      .get("chamados/listarComentarios", { chamadoId: chamadoId })
      .then((res) => {
        setComentarios(res);
      });
  };

  const carregar = () => {
    setCarregando(true);

    api
      .get("chamados/carregar", { id: chamadoId })
      .then((res) => {
        setChamado(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar chamado");
        setCarregando(false);
      });
  };

  const salvarUsuario = (campo, value) => {
    if (campo === "responsavelUsuarioId") {
      const data = new FormData();
      data.append("chamadoId", chamado.id);
      data.append("responsavelUsuarioId", value);

      api
        .post("chamados/alterarResponsavel", data)
        .then((res) => {
          notification("success", "Responsável alterado");
          carregar();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification(
                "error",
                "Operação não permitida para o solicitante"
              );
            case 2:
              return notification("error", "Responsável inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const concluirChamado = () => {
    confirm({
      title: "Confirma a conclusão da solicitação?",
      label: "",
      onConfirm: () => {
        api
          .post("chamados/registrarConclusao", { chamadoId: chamado.id })
          .then((res) => {
            notification("success", "Chamado concluído");
            carregar();
          })
          .catch((err) => {
            const { data } = err;
            switch (data[0]) {
              case 1:
                return notification(
                  "error",
                  "Operação não permitida para o solicitante"
                );
              default:
                return notification("error", "Dados inválidos");
            }
          });
      },
    });
  };

  const cancelarChamado = () => {
    confirm({
      title: "Confirma o cancelamento da solicitação?",
      label: "",
      onConfirm: () => {
        api
          .post("chamados/registrarCancelamento", {
            chamadoId: chamado.id,
          })
          .then((res) => {
            notification("success", "Chamada cancelada");
            carregar();
          })
          .catch((err) => {
            const { data } = err;
            switch (data[0]) {
              case 1:
                return notification(
                  "error",
                  "Operação não permitida para o solicitante"
                );
              default:
                return notification("error", "Dados inválidos");
            }
          });
      },
    });
  };

  const reabrirChamado = () => {
    confirm({
      title: "Confirma a reabertura da solicitação?",
      label: "",
      onConfirm: () => {
        api
          .post("chamados/registrarReabertura", {
            chamadoId: chamado.id,
          })
          .then((res) => {
            notification("success", "Chamada reaberta");
            carregar();
          })
          .catch((err) => {
            const { data } = err;
            switch (data[0]) {
              case 1:
                return notification(
                  "error",
                  "Operação não permitida para o solicitante"
                );
              default:
                return notification("error", "Dados inválidos");
            }
          });
      },
    });
  };

  const montarForm = () => {
    const campos = {};

    campos.criadoPor = {
      label: "Criado por",
      type: "text",
      value: chamado.usuarioNome,
      readOnly: true,
      space: 6,
    };
    campos.criadoEm = {
      label: "Aberta em",
      type: "text",
      value: formatDateTime(chamado.criacao, "D/M/Y h:m"),
      readOnly: true,
      space: 6,
    };
    campos.titulo = {
      label: "Título",
      type: "text",
      value: chamado.titulo,
      readOnly: true,
      space: 12,
    };
    campos.descricao = {
      label: "Descrição",
      type: "textarea",
      value: chamado.descricao,
      readOnly: true,
      space: 12,
    };

    campos.responsavelUsuarioId = {
      label: "Responsável",
      space: 12,
      value: chamado.responsavelUsuarioId,
      type: "select",
      emptyItem: true,
      disabled: usuario.usuario.usuarioId === chamado.usuarioId ? false : true,
      array: {
        data: responsaveis,
        value: "usuarioId",
        desc: "usuarioNome",
      },
    };

    if (chamado.anexoNome) {
      campos.componente = {
        type: "component",
        value: (
          <div>
            <h4>Anexo</h4>
            <a
              href={`${serverHost()}/${chamado.anexoURI}`}
              target="_blank"
              rel="noopener noreferrer"
              download={chamado.anexoNome}
            >
              {chamado.anexoNome}
            </a>
          </div>
        ),
      };
    }

    if (
      chamado.usuarioId === usuario.usuario.usuarioId ||
      chamado.responsavelUsuarioId === usuario.usuario.usuarioId
    ) {
      if (chamado.situacao === 1) {
        campos.custom = {
          type: "component",
          value: (
            <Stack spacing={2} direction={"row"}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => history.goBack()}
              >
                Fechar
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={cancelarChamado}
              >
                cancelar
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ color: "white" }}
                onClick={concluirChamado}
              >
                Concluir
              </Button>
            </Stack>
          ),
        };
      }
      if (chamado.situacao === 2 || chamado.situacao === 3) {
        campos.custom = {
          type: "component",
          value: (
            <Stack spacing={2} direction={"row"}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => history.goBack()}
              >
                Fechar
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ color: "white" }}
                onClick={reabrirChamado}
              >
                Reabrir
              </Button>
            </Stack>
          ),
        };
      }
    } else {
      campos.custom = {
        type: "component",
        value: (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => history.goBack()}
          >
            Fechar
          </Button>
        ),
      };
    }

    const form = {
      title: "Solicitação",
      form: campos,
      autoSave: salvarUsuario,
    };

    return form;
  };

  const inserirComentario = () => {
    const data = new FormData();
    data.append("chamadoId", chamado.id);
    data.append("texto", comentario);

    if (dadosAnexo.length) {
      dadosAnexo.forEach((file, index) => data.append("anexo", file));
    }

    setInserindo(true);

    api
      .post("chamados/inserircomentario", data)
      .then(() => {
        notification("success", "Comentário inserido!");
        setComentario("");
        carregarComentarios();
        setInserindo(false);

        if (dadosAnexo.length) {
          setDadosAnexo([]);
          setExibindoAnexo(!exibindoAnexo);
        }
      })
      .catch((err) => {
        setInserindo(false);
        console.log(err);
        const { data } = err;

        switch (data[0]) {
          case 1:
            return notification("error", "Conteúdo inválido");
          default:
            return notification("error", "Erro ao inserir comentário");
        }
      });
  };

  const fileUpload = (e, campo) => {
    e.preventDefault();

    let files;

    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    const uploadedFiles = [];

    const fileLoad = (file) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        uploadedFiles.push(file);

        if (uploadedFiles.length === files.length) {
          setDadosAnexo(uploadedFiles);
        }
      };
    };

    for (let i = 0; i < files.length; i++) {
      fileLoad(files[i]);
    }
  };

  const excluirComentario = (id) => {
    confirm({
      title: "Confirma a exclusão do comentário?",
      label: "Não será possível desfazer esta ação.",
      onConfirm: () => {
        api
          .post("chamados/removerComentario", {
            chamadoComentarioId: id,
          })
          .then((res) => {
            notification("success", "Comentário excluído!");
            carregarComentarios();
          })
          .catch((err) => {
            const { data } = err;

            switch (data[0]) {
              case 1:
                return notification("error", "Comentário já excluído");

              default:
                return notification(
                  "error",
                  "Não foi possível excluir o comentário"
                );
            }
          });
      },
    });
  };

  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={montarForm()} />}

      <Grid
        style={{
          padding: 5,
          backgroundColor: "white",
          borderRadius: 10,
          color: "black",
        }}
        container
        spacing={2}
      >
        <Grid style={{ padding: 10 }} size={12}>
          <h4>Comentários</h4>
        </Grid>
        {comentarios.length > 0 && (
          <>
            {comentarios.map((comentario) => (
              <>
                <Grid
                  style={{
                    background: "#d0f7f7",
                    padding: 10,
                    borderRadius: 15,
                  }}
                  size={12}
                >
                  <Grid size={12} container>
                    <h4>{comentario.usuarioNome}</h4>
                  </Grid>

                  <Grid size={12} container>
                    {comentario.anexoNome ? (
                      <div>
                        <a
                          href={`${serverHost()}/${comentario.anexoURI}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          download={comentario.anexoNome}
                        >
                          {comentario.anexoNome}
                        </a>
                      </div>
                    ) : (
                      <Typography paragraph>{comentario.texto}</Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid size={12} style={{ textAlign: "end" }}>
                  {formatDateTime(comentario.dataHora, "D/M/Y hh:mm")}
                  {comentario.usuarioId === usuario.usuario.usuarioId && (
                    <>
                      <IconButton
                        onClick={() => {
                          excluirComentario(comentario.id);
                        }}
                      >
                        <Tooltip title="Excluir comentário">
                          <DeleteIcon />
                        </Tooltip>
                      </IconButton>
                    </>
                  )}
                </Grid>
              </>
            ))}
          </>
        )}
        {!exibindoAnexo ? (
          <Grid size={12} container>
            <Grid size={12}>
              <TextField
                id="outlined-multiline-flexible"
                label={"Novo comentário"}
                multiline
                maxRows={4}
                fullWidth
                onChange={(event) => setComentario(event.target.value)}
                value={comentario}
              />
            </Grid>
            <Grid
              spacing={2}
              style={{
                paddingTop: 10,
              }}
              size={12}
            >
              {inserindo ? (
                <CircularProgress />
              ) : (
                <Stack direction="row" spacing={2}>
                  <Button
                    style={{ color: "white" }}
                    variant="contained"
                    onClick={() => inserirComentario()}
                  >
                    Enviar
                  </Button>

                  <IconButton
                    onClick={() => {
                      setExibindoAnexo(!exibindoAnexo);
                    }}
                  >
                    <Tooltip title="Anexar arquivos">
                      <AttachFileIcon />
                    </Tooltip>
                  </IconButton>
                </Stack>
              )}
            </Grid>
          </Grid>
        ) : (
          <Grid size={12} container>
            <Grid size={12}>
              <TextField
                id="outlined-basic"
                type="file"
                variant="outlined"
                inputProps={{
                  multiple: true,
                }}
                fullWidth
                onChange={(e) => fileUpload(e)}
              />
            </Grid>

            <Grid
              spacing={2}
              style={{
                paddingTop: 10,
              }}
              size={12}
            >
              {inserindo ? (
                <CircularProgress />
              ) : (
                <Stack direction="row" spacing={2}>
                  <Button
                    style={{ color: "white" }}
                    variant="contained"
                    onClick={() => inserirComentario()}
                  >
                    Enviar
                  </Button>

                  <Button
                    style={{ color: "white" }}
                    color="secondary"
                    variant="contained"
                    onClick={() => setExibindoAnexo(!exibindoAnexo)}
                  >
                    Cancelar
                  </Button>
                </Stack>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
